// extracted by mini-css-extract-plugin
export default {"ContentPresenter":"ContentPresenter_ContentPresenter__z3DBO"};